// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.semi-popover-wrapper:has(.\\------packages-components-bot-semi-src-components-ui-cascader-index-module__ui-cascader-dropdown-L0OzIh) {
  background: var(--light-usage-bg-color-bg-3, #fff);
  border-radius: 6px;
}

.\\------packages-components-bot-semi-src-components-ui-cascader-index-module__ui-cascader-XmWyTb.semi-cascader.semi-cascader-disabled {
  background-color: var(--semi-color-disabled-fill);
}

.\\------packages-components-bot-semi-src-components-ui-cascader-index-module__ui-cascader-XmWyTb:not(.semi-cascader-disabled) div {
  color: #1d1c23;
}

.\\------packages-components-bot-semi-src-components-ui-cascader-index-module__ui-cascader-XmWyTb:not(.semi-cascader-disabled) span:not(.semi-cascader-selection-placeholder) {
  color: #1d1c23;
}

.\\------packages-components-bot-semi-src-components-ui-cascader-index-module__ui-cascader-dropdown-L0OzIh .semi-cascader-option-lists .semi-cascader-option-list {
  padding: 4px 6px;
}

.\\------packages-components-bot-semi-src-components-ui-cascader-index-module__ui-cascader-dropdown-L0OzIh .semi-cascader-option-lists .semi-cascader-option {
  font-weight: 600;
}

.\\------packages-components-bot-semi-src-components-ui-cascader-index-module__ui-cascader-dropdown-L0OzIh .semi-cascader-option-lists .semi-cascader-option:not(:first-child) {
  margin-top: 4px;
}

.\\------packages-components-bot-semi-src-components-ui-cascader-index-module__ui-cascader-dropdown-L0OzIh .semi-cascader-option-lists .semi-cascader-option:hover {
  background: var(--light-usage-fill-color-fill-1, rgba(46, 46, 56, .08));
  border-radius: 4px;
}

.\\------packages-components-bot-semi-src-components-ui-cascader-index-module__ui-cascader-dropdown-L0OzIh .semi-cascader-option-lists .semi-cascader-option-active {
  color: var(--light-usage-primary-color-primary, #4d53e8);
  background: var(--light-usage-fill-color-fill-1, rgba(46, 46, 56, .08));
  border-radius: 4px;
}

.\\------packages-components-bot-semi-src-components-ui-cascader-index-module__ui-cascader-dropdown-L0OzIh .semi-cascader-option-lists .semi-cascader-option-select {
  color: var(--light-usage-primary-color-primary, #4d53e8);
  background: var(--light-usage-fill-color-fill-1, rgba(46, 46, 56, .08));
  border-radius: 4px;
}

.\\------packages-components-bot-semi-src-components-ui-cascader-index-module__ui-cascader-dropdown-L0OzIh .semi-cascader-option-lists .semi-cascader-option-active .semi-cascader-option-icon {
  color: var(--light-usage-primary-color-primary, #4d53e8);
}

.\\------packages-components-bot-semi-src-components-ui-cascader-index-module__ui-cascader-dropdown-L0OzIh .semi-cascader-option-lists .semi-cascader-option-select .semi-cascader-option-icon {
  color: var(--light-usage-primary-color-primary, #4d53e8);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ui-cascader-dropdown": `------packages-components-bot-semi-src-components-ui-cascader-index-module__ui-cascader-dropdown-L0OzIh`,
	"uiCascaderDropdown": `------packages-components-bot-semi-src-components-ui-cascader-index-module__ui-cascader-dropdown-L0OzIh`,
	"ui-cascader": `------packages-components-bot-semi-src-components-ui-cascader-index-module__ui-cascader-XmWyTb`,
	"uiCascader": `------packages-components-bot-semi-src-components-ui-cascader-index-module__ui-cascader-XmWyTb`
};
export default ___CSS_LOADER_EXPORT___;
